<div class="select-input-root">
  <button type="button" class="select-input-trigger" [class.disabled]="disabled" (click)="toggleOpen()">
    <span [class.placeholder]="!value">{{ selectedLabel }}</span>
    <i class="fas fa-chevron-down text-gray-400 ml-auto text-xs"></i>
  </button>

  <div class="select-input-popup" *ngIf="isOpen">
    <button type="button" *ngFor="let option of options" class="option-row" [class.selected]="option.value === value"
      (click)="select(option)">
      {{ option.label }}
    </button>
  </div>
</div>
